import { ConfirmModal } from '@sifrovacihra/shared-ui'

type DisclaimerModalProps = {
    open: boolean
    handleClose: () => void
    onAccept: () => void
}

export const DisclaimerModal = ({ open, handleClose, onAccept }: DisclaimerModalProps) => {
    return (
        <ConfirmModal
            visible={open}
            onCloseClick={handleClose}
            headline='Souhlas se zpracováním osobních údajů'
            onConfirm={onAccept}
            confirmText='Souhlasím'
        >
            <div className='disclaimer'>
                <p>Přihlášením se do hry dáváte souhlas se zpracováním a uchováním osobních údajů pro potřeby organizace hry.</p>
                <p>Veřejně zveřejňujeme jméno týmu a jména jeho členů. Ostatní údaje jsou sdíleny pouze Městské knihovně Tábor a administrátorům webu sifrovacihra.cz. Telefonní čísla, města a věky hráčů nejpozději rok po konání hry smažeme z databáze. Mail může být použit pro pozvání na další ročník ŠifTu nebo na jinou námi organizovanou hru. Pokud nebudete chtít dostávat tyto pozvánky, mail na vyžádání smažeme.</p>
                <p>Fotky pořízené na hře slouží k reportážním účelům a budou vystaveny zde nebo na veřejných úložištích. Pokud nebudete souhlasit se zveřejněním fotografie, na které jste zachyceni, na požádání danou fotku odstraníme.</p>
            </div>
        </ConfirmModal>
    )
}
